import { Button, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useCompleteNegotiationRoundV2Mutation, type NegotiationRoundV2Dto } from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { useConfirmationModal } from "../../../../common/useConfirmationModal";

export const CompleteRoundButton = ({ round }: { round: NegotiationRoundV2Dto }) => {
  const { t } = useTranslation();
  const { trigger } = useApiError();
  const toast = useToast();
  const confirmationModal = useConfirmationModal();
  const [completeRound, { isLoading }] = useCompleteNegotiationRoundV2Mutation();

  const confirmCompletion = () =>
    confirmationModal.show({
      title: t("Complete negotiation round?"),
      description: t("Suppliers will no longer be able to submit bids for this round."),
      confirmButtonText: t("Complete round") ?? "Complete round",
      onConfirmed: async () => {
        try {
          await completeRound({ eventId: round.eventId, roundId: round.id }).unwrap();
          toast({ title: t("Negotiation round completed"), status: "success" });
        } catch (e) {
          trigger(e);
        }
      },
    });

  return (
    <>
      {confirmationModal.modal}
      <Button colorScheme="orange" variant="outline" size="sm" onClick={confirmCompletion} isLoading={isLoading}>
        {t("Complete round")}
      </Button>
    </>
  );
};
